<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CbxE7i/tc-custom/cover.jpg?1684515194738?1702529291356" alt="This image is the cover for the book Lost Biloxi, Lost"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Biloxi, Lost
      </h1>
      <p class="bookDescription body article font2">
        <p>Biloxi's beaches and casinos make the city a haven for Gulf Coast tourists. And since it's one of America's oldest communities, local residents have seen many iconic treasures come and go. Before Hurricane Katrina, more than 150 historical structures dotted the area. Of those, 60 were lost to the devastating storm, including the Father Ryan House, built in the early 1840s. In 1969, Hurricane Camille flattened the Baldwin Wood Lighthouse. Other structures like Biloxi City Hall on Main Street faded away with the passage of time, having stood resolute for decades. Author Edmond Boudreaux recalls Biloxi's most significant and cherished landmarks.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edmond Boudreaux
      </h2>
      
      <p class="authorDescription body article">Edmond Boudreaux's passion for Mississippi history led him to become a community advisory committee member for the Mississippi State Historical Museum. He has served as advisory board member and former president of the Maritime & Seafood Industry Museum. In 2011, the Mississippi Department of Archives & History recognized Edmond's work for historical causes, the MDAH and Gulf Coast studies with a Resolution of Commendation award. He is the 1993 recipient of Biloxi's Historian of the Year award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8fcf3efc